var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewingOn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "9px",
    viewBox: "0 0 12 9",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "UI/Glyphs/Site &amp; Asset/Overview") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.5938134,1.05742543 C9.32798348,1.41091472 9.9860174,1.91788484 10.5473705,2.56081238 C11.105098,3.19769737 11.5413703,3.93730574 11.8434979,4.75607154 L12,5.18086295 L10.7926981,6.58152652 C10.2259067,7.22807959 9.5678728,7.73504971 8.83430698,8.09035177 C8.06690286,8.46136447 7.24994983,8.65049635 6.40701381,8.65049635 C5.56226504,8.65049635 4.74470774,8.46136447 3.97669937,8.09035177 C3.58212072,7.89880287 3.20929526,7.66314334 2.86124426,7.38699871 C2.72709961,7.28064979 2.71380599,7.08003707 2.82680172,6.95193496 L3.12772081,6.60932226 C3.23406973,6.48786696 3.41413778,6.47699037 3.54163563,6.57669248 C3.82321855,6.79784988 4.12353339,6.98637751 4.43714184,7.13864982 C5.06073321,7.44017317 5.72360118,7.59304974 6.40701381,7.59304974 C7.08861369,7.59304974 7.75027314,7.44017317 8.37386451,7.13864982 C8.97872397,6.8461903 9.52497068,6.42381591 9.9914557,5.89146708 L10.7908853,4.96393533 C10.5370981,4.32886311 10.1878386,3.75542492 9.75156638,3.25631012 C9.28326859,2.72033575 8.73883465,2.30098264 8.13337094,2.00912738 C7.52186467,1.71364658 6.84147331,1.55774874 6.16591599,1.55774874 C5.49035867,1.55774874 4.8099673,1.71364658 4.19785678,2.00973163 C3.59481008,2.30037839 3.0509804,2.7197315 2.58086985,3.25691438 C2.10894653,3.79591002 1.73732958,4.42735671 1.48172963,5.11862467 L1.01041057,6.41596059 C0.953610579,6.57246269 0.779585079,6.65343289 0.623082981,6.5966329 L0.198291571,6.44133931 C0.041789473,6.38453932 -0.0385764694,6.21111808 0.0182235199,6.05461598 L0.484708539,4.76634388 C0.792878694,3.93368021 1.2285467,3.19648886 1.78446149,2.56081238 C2.34762734,1.91788484 3.00445275,1.41091472 3.73862282,1.05742543 C5.27584807,0.314191524 7.05658816,0.314191524 8.5938134,1.05742543 Z M6.3702751,2.50111197 C7.50687914,2.50111197 8.42836833,3.4219969 8.42836833,4.5592052 C8.42836833,5.6964135 7.50687914,6.61729843 6.3702751,6.61729843 C5.23427531,6.61729843 4.31278612,5.6964135 4.31278612,4.5592052 C4.31278612,3.4219969 5.23427531,2.50111197 6.3702751,2.50111197 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TASK",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PANEL->-TASK->-Field->-Unsched-Notes-&-Attachments",
    transform: "translate(-756.000000, -501.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(726.000000, 498.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(30.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Foreground",
    transform: "translate(0.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fill: "#38434E",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, -1.000000)",
    id: "Color/UI/Slate/Slate-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#C5D2DE",
    x: 0,
    y: 0,
    width: 12,
    height: 12
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewingOn);
export default __webpack_public_path__ + "static/media/viewing_on.de5292f72cbec52af509cead5cb26ca1.svg";
export { ForwardRef as ReactComponent };